import React from "react";
import { Navigate } from "react-router-dom";
import { getFirstAccessibleAdminPath, getStoredAdminPermissions } from "../utils/adminAccess";

const getAuthState = () => {
  const token = localStorage.getItem("token");
  const employee = JSON.parse(localStorage.getItem("employeeUser") || "null");
  const admin = JSON.parse(localStorage.getItem("adminData") || "null");
  const role = employee ? "employee" : (admin ? "admin" : null);
  return { token, role, admin };
};

const ProtectedRoute = ({ scope = "any", permission, children }) => {
  const { token, role, admin } = getAuthState();
  if (!token || !role) return <Navigate to="/" replace />;

  if (scope !== "any" && role !== scope) {
    return <Navigate to={role === "employee" ? "/AttendanceSignIn" : "/Dashboard"} replace />;
  }

  if (scope === "admin" && permission) {
    const permissions = getStoredAdminPermissions();
    const normalizedRole = String(admin?.role || "").toLowerCase().replace(/\s+/g, "");
    const hasAllAccess = permissions.includes("ALL") || permissions.includes("all");
    const isFullAccessRole = ["mainadmin", "superadmin", "root"].includes(normalizedRole);

    if (!hasAllAccess && !isFullAccessRole && !permissions.includes(permission)) {
      return <Navigate to={getFirstAccessibleAdminPath(admin, permissions)} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
